import React from 'react';
import {PolIcon} from "components/PolIcon/policon";
import InputSimpleCheckbox from "v4/components/form/Field/components/InputSimpleCheckbox/InputSimpleCheckbox";
import apiService from "v4/services/api.service";
import {IMAGE} from "v4/data/apiRoutes";

import 'v4/components/form/Field/components/InputFile/components/DocumentsHolder/DocumentsHolder.scss';

export default function DocumentsHolder({multiple, serverFiles, fieldName, onToggleDelete}) {
    return (
        <div className={`documents-holder${multiple ? ' multiple' : ''}`}>
            {serverFiles.map(({dto, index}) => (
                <div key={dto.id ?? index} className={getDocumentClassName(dto, multiple)}>
                    {!multiple && ['image/jpeg', 'image/png'].includes(dto.mimeType)
                        ? <img src={apiService.generateUrl(IMAGE, {id: dto.id})} alt={dto.label}/>
                        : (
                            <p>
                                <PolIcon icon="file" className="file-icon"/>
                                <span>{dto.label}</span>
                            </p>
                        )
                    }
                    <label className="document-delete">
                        <InputSimpleCheckbox fieldName={`${fieldName}[${index}][shouldDelete]`}
                                             fieldValue={dto.shouldDelete}
                                             prefix=""
                                             onChange={checked => onToggleDelete(index, checked)}/>
                        <PolIcon icon="trash" className="delete-icon"/>
                    </label>
                </div>
            ))}
        </div>
    )
}

function getDocumentClassName(dto, multiple) {
    const isImage = !multiple && ['image/jpeg', 'image/png', 'image/webp'].includes(dto.mimeType);

    return `document${isImage ? ' is-image' : ''}${dto.shouldDelete ? ' is-delete' : ''}`;
}
